/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'ssn',
  template: require('./ssn.component.html')
})
export class SSNComponent extends BaseRoute {

  constructor(injector: Injector) {
    super(injector);
  }

  btnClick(e) {
    if (e.action === 'next') {
      if (!this.flowManager.isAuthed) {
        this.modal.loadingModel();

        const personalInfo = this.appActions.getData('PersonalInformation', {});
        const yourInfo = this.appActions.getData('YourInformation', {});
        const payload = {
          lastName: yourInfo.lastName,
          dateOfBirth: personalInfo.dob,
          identificationNumber: personalInfo.ssn
        };
        this.appProxy.custFuzzySearch(payload, resp => {

          if (resp.matchNoCredentialsFound && resp.matchNoCredentialsFound === true) {
            this.modal.matchNoCredentialsFoundModal();
          } else if (resp.matchFound && resp.matchFound === true) {
            this.modal.matchFound();
          } else {
            const nextRoute = this.getActionRoute(e.action);
            this.modal.closeModal(nextRoute);
            return;
          }
        });
        return;
      }
    }

    this.handleClick(e.action);
  }
}
